import { render, staticRenderFns } from "./ChangeAnimation.vue?vue&type=template&id=c31201e6&"
import script from "./ChangeAnimation.vue?vue&type=script&lang=js&"
export * from "./ChangeAnimation.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAnimation.vue?vue&type=style&index=0&id=c31201e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports